import { useRoutes } from 'react-router-dom';

import LandingPageLayout from '../layout/LandingPageLayout';
import Contact from '../pages/Contact/Contact';
import Home from '../pages/Home/Home';
import NotFound from '../pages/NotFound/NotFound';
import Track from '../pages/Track/Track';
import {
 BECOME_A_PARTNER,
 CONTACT,
 GLOBAL_IMPORTS,
 HOME,
 IMPORT_FROM_CHINA,
 JOIN_WAITLIST,
 PAYMENT_SUCCESS,
 TRACK,
} from './routeConstants';
import BecomeAPartner from '../pages/BecomeAPartner/BecomeAPartner';
import JoinWaitlist from '../pages/JoinWaitList/JoinWaitlist';
import ImportFromChina from '../pages/ImportFromChina/ImportFromChina';
import GlobalImports from '../pages/GlobalImports/GlobalImports';
import PaymentSuccessful from '../pages/PaymentSuccessful/PaymentSuccessful';

export default function Router() {
 return useRoutes([
  {
   path: HOME,
   element: <LandingPageLayout />,
   children: [
    { path: HOME, element: <Home /> },
    {
     path: `${TRACK}/:trackingId?`,
     element: <Track />,
    },
    {
     path: BECOME_A_PARTNER,
     element: <BecomeAPartner />,
    },
    {
     path: IMPORT_FROM_CHINA,
     element: <ImportFromChina />,
    },
    {
     path: GLOBAL_IMPORTS,
     element: <GlobalImports />,
    },
    {
     path: JOIN_WAITLIST,
     element: <JoinWaitlist />,
    },
    {
     path: CONTACT,
     element: <Contact />,
    },
    { path: PAYMENT_SUCCESS, element: <PaymentSuccessful /> },
    // {
    //   path: BOOK_SHIPMENT,
    //   element: <BookShipment />,
    // },
    // {
    //   path: ABOUT_US,
    //   element: <AboutUs />,
    // },
    // {
    //   path: ABOUT_US,
    //   element: <AboutUs />,
    // },
    // {
    //   path: ENTERPRISE_LOGISTICS,
    //   element: <EnterpriseLogistics />,
    // },
    // {
    //   path: SUPPLY_CHAIN_STORAGE,
    //   element: <SupplyChainStorage />,
    // },

    // {
    //   path: CUSTOM_CLEARANCE,
    //   element: <CustomClearance />,
    // },
    // {
    //   path: LAST_MILE_DELIVERY,
    //   element: <LastMileDelivery />,
    // },
    // {
    //   path: CONTACT,
    //   element: <Contact />,
    // },
    // {
    //   path: BOUNDED_TERMINALS,
    //   element: <BoundedTerminals />,
    // },
   ],
  },

  { path: '*', element: <NotFound /> },
 ]);
}
